

module.exports = {
	/* DatePicker */
	dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	dayNamesShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	monthNames: ['January', 'February', 'March', 'April', 'May','June', 'July', 'August', 'September', 'October', 'November', 'December'],
	monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],

	/* Header Cart */
	"cart": "Cart",
	"product": "product",
	"product_plural": "products",

	/* Header Favs */
	"favorite": "favorite",
	"favorite_plural": "favorites",

	/* Collectible */
	"collectible.results": "Results",
	"collectible.of": "of",
	"next": "Next",
	"prev": "Previous",
	"remove": "Remove",

	/* SortOrderTemplate */
	sort_auto: "Best Match",
	sort_stars: "Stars",
	sort_ratings: "Ratings",
	sort_price: "Price",

	/* SidebarTemplate */
	sidebar_more: "More",

	/* result-template */
	result_validated: "Certified Quality",
	result_book_online: "Book online",
	like: "like",
	unlike: "unlike",
	result_recommentation: "recommendation",
	add_spa_tax: "plus spa tax",
	recommentation: "recommendation",
	"Tel.": "Phone",
	zzgl: "add",
	spatax: "spa tax",
	item_includes: "incl. {item}, ",

	breakfast_charge: "breakfast fee, ",
	halfboard_charge: "half board fee, ",
	fullboard_charge: "full board fee, ",

	/* result-error */
	result_error_title: "The requested search failed.",
	result_error_subtitle: "Theres a problem with your search:",
	reset_search: "Reset search",

	/* no-results */
	no_result_title: "Host ”{searchQuery}“ not found",
	no_result_match: "No host with this name in the current search results.",

	favsonly_empty_title: "No favorites found",
	favsonly_empty_text: "You have no favorites which match the current search filters.",

	/* loader-results */
	loading_text: "Finding the best host for you...",

	/* datepicker-item-info */
	datepicker_item_tip: "Tip: Click first on the arrival date, then the departure date.",
	datepicker_item_selected: "Calender highlights valid arrival days for »{name}«.",

	/* datepicker-controls */
	dp_controls_mode_none: "None",
	dp_controls_mode_exact: "Exact",
	dp_controls_mode_range: "Flexible",
	dp_controls_from: "from",
	dp_controls_to: "to",
	date_to: "-",

	/* engine/main.js */
	dd_selected_none: "No date selected",
	dd_select_date: "Please select date",
	dd_select_date_short: "Select date",

	favorites: "Favorites",
	one_favorite: "1 favorite",

	/* FormModel.js */
	people_any_count: "No people selected",

	housing_any: "Room / Apartment",
	housing_room: "Any Room",
	housing_single: "Single room",
	housing_double: "Double room",
	housing_flat: "Holiday flat",
	housing_house: "Holiday house / Lodge",
	housing_campsite: "Campsite",

	bedroom_count: "Num. bedrooms",
	bedroom: "bedroom",
	bedrooms: "bedrooms",

	adult: "adult",
	adults: "adults",
	no_adults: "no adults",
	child: "child",

	no_children: "No children",
	one_child: "1 child",
	children: "children",

	housings: "housings",


	/* NightsCompressor.js */
	night: "night",
	nights: "nights",
	at_least: "min.",
	nights_list: "{nights} and {last_item} nights",

	/* timetable-template */
	today: "today",

	/* ratings-template */
	add_rating: "Write rating",

	rating_1: "Offerings",
	rating_2: "Tidyiness",
	rating_3: "Friendliness",
	rating_4: "Recommendation",

	age: "Age",
	no_ratings: "Sorry, no ratings yet...",

	for_one_week: "For 1 week",
	for_two_weeks: "For 2 weeks",
	for_x_days: "For {days} days",

	in_winter: "In winter",
	in_spring: "In spring",
	in_summer: "In summer",
	in_autumn: "In autumn",
	rated_on: "Rated on",
	age_range: "{from} - {to} years",

	"traveled_as_Single": "travelled as single",
	"traveled_as_Paar": "travelled as couple",
	"traveled_as_Familie": "travelled as family",
	"traveled_as_Freunde": "travelled as friends",

	products_and_services: "Products &amp; Services",

	/* DateTime.js */
	no_date: "Nos‚election",
	one_night: "1 night",
	x_nights: "{nights} nights",

	/* classes-template */
	item_focused: "Package in focus",
	order: "Order now",
	inquiry: "Inquiry",
	total_price: "Total",
	price_no_query: "Price depends on<br/>date and people",
	search: "Search",
	packages: "Packages",
	package: "Package",

	results_404_title: "No categories found",
	results_404_prefix: "Change search parameters or",
	results_404_link: "search without date",
	price_from: "from",

	/* cart-items-template */
	cart_empty: "Cart is empty",
};




/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/translate/lang.en.js
 **/